// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__35Bhm","row":"Node_row__1i9Tx","label":"Node_label__2mbzw","footer":"Node_footer__13v8R"};